module.exports = __webpack_public_path__ + "img/49-744c31.png";